module.exports = "<svg fill=\"currentColor\" viewBox=\"0 0 40 40\"><path d=\"M25.7 12.3 18 20l7.7 7.7-2.3 2.3-10-10 10-10z\"></path></svg>"